import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

class Instructions extends Component {
	render() {
		const { franchisor } = this.props;
		const infoHtml = franchisor && franchisor.parentsInfo;

		return (<div>
			{infoHtml && <div dangerouslySetInnerHTML={{ __html: infoHtml }} />}
		</div>);
	}
}

const mapStateToProps = state => ({
	franchisor: state.configuration.franchisor
});

export default connect(mapStateToProps)(withTranslation()(Instructions));